import { render, staticRenderFns } from "./profilDetile.vue?vue&type=template&id=5d3545c8&"
import script from "./profilDetile.vue?vue&type=script&lang=js&"
export * from "./profilDetile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg})
